import { Check } from "lucide-react";
import { FINISH_LABEL, money, swatch } from "./builderLib";

const chip = (on) => `h-8 px-3 rounded-full text-xs border transition-colors ${on ? "border-sky-400 bg-sky-500/15 text-white" : "border-white/10 text-gray-400 hover:text-white"}`;

export const WrapPicker = ({ cfg, finish, setFinish, color, setColor }) => {
  const finishes = Object.keys(FINISH_LABEL).filter((f) => cfg.colors.some((c) => c.finish === f));
  const shown = cfg.colors.filter((c) => c.finish === finish);
  return (
    <div className="space-y-4" data-testid="builder-wrap-picker">
      <div className="flex flex-wrap gap-2">
        {finishes.map((f) => (
          <button key={f} onClick={() => setFinish(f)} className={chip(finish === f)} data-testid={`builder-finish-${f}`}>
            {FINISH_LABEL[f]} <span className="text-sky-300/80">{money(cfg.materials[cfg.tiers[f]])}</span>
          </button>
        ))}
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-5 gap-3">
        {shown.map((c) => (
          <button key={c.id} onClick={() => setColor(c)} className="group text-left" data-testid={`builder-color-${c.id}`}>
            <span className={`relative block aspect-square rounded-xl border-2 transition-transform group-hover:-translate-y-0.5 ${color?.id === c.id ? "border-sky-400" : "border-white/10"}`} style={{ background: swatch(c) }}>
              {color?.id === c.id && <Check className="absolute inset-0 m-auto w-5 h-5 text-white drop-shadow" />}
            </span>
            <span className="block text-[11px] text-gray-400 mt-1 leading-tight">{c.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const AddonPicker = ({ cfg, addons, setAddons }) => {
  const get = (id) => addons.find((a) => a.id === id);
  const toggle = (ad) => setAddons(get(ad.id) ? addons.filter((a) => a.id !== ad.id) : [...addons, { id: ad.id, ...(ad.colors ? { color: cfg.accent_colors[0].name, hex: cfg.accent_colors[0].hex } : {}) }]);
  const shade = (id, c) => setAddons(addons.map((a) => (a.id === id ? { ...a, color: c.name, hex: c.hex } : a)));
  return (
    <div className="space-y-2" data-testid="builder-addon-picker">
      {cfg.addons.map((ad) => {
        const on = get(ad.id);
        return (
          <div key={ad.id} className={`rounded-xl border p-3 transition-colors ${on ? "border-sky-400/60 bg-sky-500/[0.07]" : "border-white/10"}`}>
            <button onClick={() => toggle(ad)} className="w-full flex items-center justify-between gap-3 text-left" data-testid={`builder-addon-${ad.id}`}>
              <span className="flex items-center gap-3">
                <span className={`w-5 h-5 rounded-md border flex items-center justify-center ${on ? "bg-sky-500 border-sky-500" : "border-white/20"}`}>{on && <Check className="w-3.5 h-3.5 text-white" />}</span>
                <span className="text-sm text-white">{ad.name}</span>
              </span>
              <span className="text-sm text-sky-300">+{money(ad.price)}</span>
            </button>
            {on && ad.colors && (
              <div className="flex flex-wrap gap-1.5 mt-3 pl-8">
                {cfg.accent_colors.map((c) => (
                  <button key={c.name} onClick={() => shade(ad.id, c)} title={c.name} data-testid={`builder-addon-${ad.id}-color-${c.name.replace(/\W+/g, "-").toLowerCase()}`}
                    className={`w-6 h-6 rounded-full border-2 ${on.color === c.name ? "border-sky-300 scale-110" : "border-white/15"} transition-transform`} style={{ background: c.hex }} />
                ))}
                <span className="text-[11px] text-gray-400 self-center ml-1">{on.color}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export const BuildSummary = ({ price }) => (
  <div className="rounded-2xl border border-white/10 divide-y divide-white/5" data-testid="builder-summary">
    {price.items.map((i) => <div key={i.name} className="flex justify-between gap-3 px-4 py-2.5 text-sm"><span className="text-gray-400">{i.name}</span><span className="text-white">{money(i.price)}</span></div>)}
    <div className="flex justify-between px-4 py-3"><span className="text-white">Total</span><span className="text-2xl font-['Outfit'] text-white" data-testid="builder-total">{money(price.total)}</span></div>
  </div>
);
